import React from "react";
import { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface CommonLayoutProps {
    index: string;
    nextHref?: string;
    backtHref?: string;
    nextBtnText?: string;
    children: React.ReactNode;
    canGoNext?: boolean
    widePage?: boolean
    buttonPosition?: "down" | "up";
}

const CommonLayout: FC<CommonLayoutProps> = ({
	index = "01",
	children,
	nextHref,
	nextBtnText,
	backtHref,
	canGoNext,
	widePage = false,
	buttonPosition = "down",
}) => {
  const { t, ready } = useTranslation("translation");
  const navigate = useNavigate()

  if (!ready) return null;

  return (
    <div
      className={`nc-PageAddHolidayPackage1 px-4 ${widePage? "w-full" : "max-w-3xl mx-auto"} pb-24 pt-14 sm:py-24 lg:pb-32`}
      data-nc-id="PageAddHolidayPackage1"
    >
      <div className="space-y-11">

		<div className={`flex flex-row max-w-3xl mx-auto justify-between items-center`}>
			<div>
				<span className="text-4xl font-semibold">{index}</span>{" "}
				<span className="text-lg text-neutral-500 dark:text-neutral-400">/ 9</span>
			</div>
			{
				buttonPosition === "up" && (
					<div className="flex justify-end space-x-5 mt-4">
						{
							backtHref && (
								<ButtonSecondary onClick={() => navigate(backtHref)}>{t("translation:components.userActions.back")}</ButtonSecondary>
							)
						}
						{
							nextHref && (
								<ButtonPrimary disabled={!canGoNext} onClick={() => navigate(nextHref)}>
									{nextBtnText || t("translation:components.userActions.next")}
								</ButtonPrimary>
							)
						}
					</div>
				)
			}
		</div>

        <div className="listingSection__wrap ">{children}</div>

		{
			buttonPosition === "down" && (
				<div className="flex justify-end space-x-5 mt-4">
					{
						backtHref && (
							<ButtonSecondary onClick={() => navigate(backtHref)}>{t("translation:components.userActions.back")}</ButtonSecondary>
						)
					}
					{
						nextHref && (
							<ButtonPrimary disabled={!canGoNext} onClick={() => navigate(nextHref)}>
								{nextBtnText || t("translation:components.userActions.next")}
							</ButtonPrimary>
						)
					}
				</div>
			)
		}
      </div>
    </div>
  );
};

export default CommonLayout;
